import React from 'react'
import { Icon } from 'antd'
import { FormattedMessage } from 'react-intl'

import { Sticker, StickerCategory } from '../../types'
import StickerWithTag from './StickerWithTag'
import StickerUnApprovedCauseCard from './StickerUnApprovedCauseCard'
import { isStickerHasInspectionData } from '../../types/utils'
import styles from '../../styles/StickerInfoList.module.css'
export default function StickerInfoList({
  stickerList,
  style,
}: {
  stickerList: Sticker[]
  style?: any
}) {
  const unApprovedStickerList = stickerList.filter(isStickerHasInspectionData)
  const restStickerList = stickerList.filter(
    (sticker) => !isStickerHasInspectionData(sticker),
  )
  return (
    <div style={style} className={styles.wrapper}>
      <header className={styles.head}>
        <div>
          <FormattedMessage
            id={'StickerInfo.title'}
            defaultMessage={'Stickers'}
          />
        </div>
        <div>
          <a
            style={{ color: '#a202ff', fontWeight: 400 }}
            href="/guide/rejectedReasons"
            target="_blank"
          >
            <Icon type="question-circle" style={{ marginRight: 5 }} />
            <FormattedMessage
              id={'UnapprovedCause.headline'}
              defaultMessage={'Guide to Reject Reasons'}
            />
          </a>
        </div>
      </header>
      <main className={styles.stickerList}>
        {unApprovedStickerList.map((unApprovedSticker) => (
          <div
            className={styles.stickerInfoWithTag}
            key={unApprovedSticker.objectId}
          >
            <StickerWithTag
              key={unApprovedSticker.objectId}
              sticker={unApprovedSticker}
            />
            <StickerUnApprovedCauseCard
              position="right"
              unApprovedCauses={
                unApprovedSticker.stickerInspectionData.unapprovedCauses
              }
            />
          </div>
        ))}
        {restStickerList.map((sticker) => (
          <StickerWithTag key={sticker.objectId} sticker={sticker} />
        ))}
      </main>
    </div>
  )
}
